export const blockIconsImageFlashOn = (
	<span className='material-symbols-outlined'>flash_on</span>
);
